const CONTINUABLE_APPLICATION_STATUSES = [
    'prequalified',
    'pending_approval',
    'pending',
];
/** Returns the prequalifications a consumer can resume from the application-found page. */
const getContinuablePrequalifications = (prequalifications) => (prequalifications ?? []).filter((prequalification) => prequalification != null &&
    CONTINUABLE_APPLICATION_STATUSES.includes(prequalification.applicationStatus));
export default getContinuablePrequalifications;
